<template>
  <el-container class="create-body" style="overflow:initial">
    <div style="position:relative;">
      <h2>比赛内容</h2>
      <el-button type="primary" @click="addTarget" style="position:absolute;top:-10px;right:0;" v-if="type==='contest'">+添加目标</el-button>
      <el-divider></el-divider>
    </div>
    <div class="create-btn" v-if="type==='contest'">总分值：{{total_percent}}</div>
    <div class="create-content">
      <div v-for="( item , index ) in items" :name="index" :key="index" class="items-group">
        <h2 class="target-title" v-if="type==='contest'">
          <span>目标{{index+1 | NumberToChinese}}：{{item.target_title}}</span>
          <span title="修改" class="edit-btn" @click="editTarget(item.id,index)">
            <i class="el-icon-edit"></i>
          </span>
          <span title="删除" class="del-btn" @click="delTarget(item.id,index)">
            <i class="el-icon-delete"></i>
          </span>
        </h2>
        <draggable :list="item.project" :disabled="!enabled" handle=".handle" class="list-group" :id="index" @start="dragging = true" @end="projectDragEnd"
          :options="{group:'project',filter:'.undraggable',ghostClass:'ghost',dragClass:'ghost',fallbackClass:'ghost'}">
          <div class="list-group-item" v-for="(element,ind) in item.project" :key="ind">
            <div class="project-header handle" @click="setSection(index,ind)" :class="isInArray(index+'-'+ind)?'':'no-bottom'">
              <div class="project-img">
                <img :src="element.img_url?element.img_url:require('../../assets/imgs/default-icon.jpg')" />
              </div>
              <div class="project-intro">
                <p>
                  <span>项目{{ sortProNum(index,ind) | NumberToChinese }}：{{ element.project_name }}</span>
                  <span title="修改" class="edit-btn" @click="editProject(element.id,index,ind)" @click.stop>
                    <i class="el-icon-edit"></i>
                  </span>
                  <span title="删除" class="del-btn" @click="delProject(element.id,index,ind)" @click.stop>
                    <i class="el-icon-delete"></i>
                  </span>
                </p>
                <div class="introduce-text" v-html="element.project_desc">{{element.project_desc}}</div>
              </div>
            </div>
            <div v-if="isInArray(index+'-'+ind)">
              <draggable :list="element.task" :disabled="!enabled" @start="dragging = true" @end="taskDragEnd" :id="index+`-`+ind"
                :options="{group:'tasks',filter:'.add-events',ghostClass:'ghost',dragClass:'ghost',fallbackClass:'ghost'}" :key="ind">
                <div class="task-group" v-for="(task,idx) in element.task" :id="`anchor`+task.id" :key="idx">
                  <div class="task-title" :data-id="task.id">
                    <span>任务{{ idx+1 | NumberToChinese }}：{{ task.task_name }}</span>
                    <span title="修改" @click="editTask(index,ind,idx)" class="edit-btn" @click.stop>
                      <i class="el-icon-edit"></i>
                    </span>
                    <span title="删除" @click="delTask(task.id,index,ind,idx)" class="del-btn" @click.stop>
                      <i class="el-icon-delete"></i>
                    </span>
                  </div>
                  <draggable :list="task.events" :disabled="!enabled" tag="ul" class="task-group-item" @start="dragging = true" :id="index+`-`+ind+`-`+idx" @end="itemsDragEnd"
                    :options="{group:'event',filter:'',ghostClass:'ghost',dragClass:'ghost',fallbackClass:'ghost'}">
                    <li class="event-item" v-for="(it , i) in task.events" :key="i">
                      <span>{{it.paper_title}}</span>
                      <span title="修改" @click="editEvents(it.id,index,ind,idx,i)" class="edit-btn" @click.stop>
                        <i class="el-icon-edit"></i>
                      </span>
                      <span title="删除" class="del-btn" @click="delEvent(it.id,index,ind,idx,i)" @click.stop>
                        <i class="el-icon-delete"></i>
                      </span>
                      <span class="fr calc-score" @click.stop v-if="type==='contest'">
                        <el-input class="score-input" v-model.trim="it.percent" placeholder="请输入分值" @blur="editPercent(it.id,it.percent)"></el-input>
                      </span>
                    </li>
                  </draggable>
                  <li class="event-item add-events" @click="editEvents(0,index,ind,idx,0)">
                    <span>
                      <i class="el-icon-plus" style="color:#409eff;">添加活动</i>
                    </span>
                  </li>
                </div>
              </draggable>
              <div class="task-add">
                <el-button type="primary" @click="addTask(index,ind)">
                  <i class="el-icon-plus">添加任务</i>
                </el-button>
              </div>
            </div>
          </div>
        </draggable>
        <div class="project-btn">
          <el-button type="primary" @click="addProject(item.id)">
            <i class="el-icon-plus">添加项目</i>
          </el-button>
        </div>
      </div>
    </div>

    <div class="create-footer">
      <el-button type="primary" @click="savePath">保存</el-button>
      <el-button plain @click="next()">下一步</el-button>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogTargetVisible" width="500px" :close-on-click-modal="false" :before-close="beforeTargetClose" :destroy-on-close="true">
      <el-form :model="setting" :rules="settingRules" ref="targetForm">
        <el-form-item :label="dialogLab+`:`" :label-width="formLabelWidth" prop="name">
          <el-input v-model.trim="setting.name" autocomplete="off" @keyup.enter.native="saveTarget('targetForm',dataType)"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeTargetClose">取 消</el-button>
        <el-button type="primary" @click="saveTarget('targetForm',dataType)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogTaskVisible" class width="500px" :close-on-click-modal="false" :before-close="beforeTaskClose" :destroy-on-close="true">
      <el-form :model="setting" :rules="settingRules" ref="taskForm">
        <el-form-item :label="dialogLab+`:`" :label-width="formLabelWidth" prop="name">
          <el-input v-model.trim="setting.name" autocomplete="off" @keyup.enter.native="saveTask('taskForm',dataType)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeTaskClose">取 消</el-button>
        <el-button type="primary" @click="saveTask('taskForm',dataType)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="dialogTitle" class="projectset" :visible.sync="dialogProjectVisible" :close-on-click-modal="false" :before-close="closeProjectDialog">
      <Project @close="closeProjectDialog" :projectData="projectData" ref="mychild" v-if="dialogProjectVisible"></Project>
    </el-dialog>
  </el-container>
</template>
<script>
import draggable from "vuedraggable";
import Project from "@/views/contest/create-project";
import {
  selectPathData,
  saveTargetTitleData,
  deleteTargetData,
  deleteProjectData,
  saveTargetProjectTaskTitleData,
  deleteTaskSettingData,
  saveTestTitleData,
  deleteTargetProjectTaskActivityData,
  dragToRefresh,
  resetPercent,
  savePathData,
  projectDragToRefreshData,
  taskDragToRefreshData,
  itemDragToRefreshData,
  NumberToChinese
} from "@/api/contest";
export default {
  name: "Content",
  components: {
    draggable,
    Project
  },
  created() {
  },
  mounted() {
    this.competitionId = this.$route.params.competitionId;
    this.initData();
    //保存目标展开状态，编辑内容返回后要保持这种状态
    let activeNames = sessionStorage.getItem("activeNames");
    if (activeNames) {
      this.activeNames = JSON.parse(activeNames);
    }
    //创建或者编辑项目更新本地items列表
    this.$root.$on("returnProject", subjectObj => {
      if (Object.keys(subjectObj).length > 0) {
        let tarIndex = this.items.findIndex(val => {
          return val.id === subjectObj.target_id;
        });
        let ind = 0;
        if (tarIndex !== -1) {
          let index = this.items[tarIndex]["project"].findIndex(val => {
            return val.id === subjectObj.id;
          });
          if (index === -1) {
            this.items[tarIndex]["project"].push(subjectObj);
            ind = this.items[tarIndex]["project"].length - 1;
          } else {
            ind = index;
            this.items[tarIndex]["project"][index].project_name =
              subjectObj.project_name;
            this.items[tarIndex]["project"][index].img_url = subjectObj.img_url;
            this.items[tarIndex]["project"][index].project_desc =
              subjectObj.project_desc;
            this.items[tarIndex]["project"][index].percent = subjectObj.percent;
          }
        }
        this.dataType = '';
        //添加或者编辑项目默认展开当前项目
        let i = this.activeNames.findIndex(val => {
          return val === tarIndex + "-" + ind;
        });
        if (i === -1) {
          this.activeNames.push(tarIndex + "-" + ind);
        }
        this.dialogProjectVisible = false;
      }
    });

  },
  data() {
    const validator = function (rule, value, callback) {
      let errors = [];
      if (value.length > 30 || !value) {
        callback("请输入1-30位字符!");
      }
      callback(errors);
    };
    const percentValid = function (rule, value, callback) {
      var errors = [];
      if (value) {
        if (!/^[0-9]+$/.test(value)) {
          callback("请输入0-100以内的正整数!");
        }
        if (value > 100) {
          callback("请输入0-100以内的正整数!");
        }
      }
      callback(errors);
    };
    return {
      type: '',//竞练类型
      dragging: false,
      enabled: true,
      items: [],
      activeNames: ["0-0"], //默认折叠
      competitionId: "", //竞赛id
      formLabelWidth: "90px",
      dialogTargetVisible: false, //
      dialogTaskVisible: false, //
      dialogProjectVisible: false, //
      dialogTitle: "", //弹窗标题
      dialogLab: "", //弹窗leble
      targetIndex: "", //编辑目标时的下标
      projectIndex: "", //编辑项目时的下标
      taskIndex: "", //编辑任务时的下标
      dataType: 0, //编辑或者创建类型，0为创建，1为编辑
      projectData: "", //项目内容
      setting: {
        name: "",
        percent: ""
      },
      settingRules: {
        name: [
          { required: true, validator: validator, trigger: "blur" },
          { validator: validator, trigger: "change" }
        ],
        percent: [
          { validator: percentValid, trigger: "blur" },
          { validator: percentValid, trigger: "change" }
        ]
      },
      nodeNum: [],
      taskNum: {},
      competitionId: "", //竞赛id
      total_percent: 0,//竞赛总分值
    };
  },
  watch: {
    activeNames: {
      deep: true,
      handler(newVal, oldVal) {
        sessionStorage.setItem("activeNames", JSON.stringify(newVal));
      }
    },
    items: {
      deep: true,
      handler(oldVal, newVal) {
        this.calcProNum();
        this.calcTaskNum()
      }
    }
  },
  methods: {
    //下一步
    next() {
      this.$router.push({
        name: "course-judge",
        query: { from: this.$route.query.from }
      });
    },
    initData: function () {
      let params = {
        competition_id: this.competitionId
      };
      selectPathData(params).then(response => {
        this.type = response.type;
        this.items = response.data
        this.calcAllocated(response.data);
        //加载数据完成后执行锚点
        this.$nextTick(() => {
          this.getLocal()
        })
      });
    },
    //添加目标
    addTarget: function () {
      this.dialogTargetVisible = true;
      this.dialogTitle = "添加目标";
      this.dialogLab = "目标名称";
    },
    //修改目标,id：目标id,index：目标index
    editTarget: function (id, index) {
      this.dialogTargetVisible = true;
      this.dialogTitle = "编辑目标";
      this.dialogLab = "目标名称";
      this.setting.name = this.items[index].target_title;
      this.setting.percent = this.items[index].percent;
      this.targetIndex = index;
      this.dataType = 1;
    },
    //保存目标,formName为表单ref,dataType为创建或者编辑类型
    saveTarget: function (formName, dataType) {
      let title = this.setting.name;
      let percent = this.setting.percent;
      let id = "";
      if (dataType) {
        let index = this.targetIndex;
        if (
          title === this.items[index].target_title &&
          percent === this.items[index].percent
        ) {
          this.beforeTargetClose();
          return true;
        }
        id = this.items[index].id;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            competition_id: this.competitionId,
            target_id: id,
            target_title: title,
            percent: percent ? percent : 0
          };
          saveTargetTitleData(params).then(response => {
            if (dataType) {
              this.items[this.targetIndex].target_title = title;
              this.items[this.targetIndex].percent = percent;
            } else {
              this.items.push(response.data);
            }
            this.calcAllocated(this.items);
            this.dataType = "";
            this.$message.success("保存成功");
            this.beforeTargetClose();
          });
        }
      });
    },
    //删除目标,id为目标id,index为目标index
    delTarget: function (id, index) {
      this.$confirm("此操作将永久删除该目标, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (!id) {
            return true;
          }
          this.items.splice(index, 1);
          let params = {
            competition_id: this.competitionId,
            target_id: id
          };
          deleteTargetData(params).then(response => {
            this.$message.success("删除成功!");
          });
        })
        .catch(() => { });
    },
    //添加项目
    addProject: function (id) {
      this.dialogProjectVisible = true;
      this.dialogTitle = "添加项目";
      this.projectData = {
        target_id: id
      };
    },
    //编辑项目,id为项目id，tarIndex为上级目标index，index为项目index
    editProject: function (id, tarIndex, index) {
      this.dialogProjectVisible = true;
      this.dialogTitle = "编辑项目";
      this.dataType = 1;
      this.projectData = {
        id: this.items[tarIndex]["project"][index].id,
        project_name: this.items[tarIndex]["project"][index].project_name,
        img_url: this.items[tarIndex]["project"][index].img_url,
        project_desc: this.items[tarIndex]["project"][index].project_desc,
        percent: this.items[tarIndex]["project"][index].percent,
        target_id: this.items[tarIndex]["project"][index].target_id
      };
    },
    //删除项目,id为项目id,tarIndex为上级目标index，index为项目index
    delProject: function (id, tarIndex, index) {
      this.$confirm("此操作将永久删除该项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (!id) {
            return true;
          }
          this.items[tarIndex]["project"].splice(index, 1);
          let params = {
            competition_id: this.competitionId,
            project_id: id
          };
          deleteProjectData(params).then(response => {
            this.$message.success("删除成功");
          });
        })
        .catch(() => { });
    },
    //添加任务,tarIndex为目标index，proIndex为项目index
    addTask: function (tarIndex, proIndex) {
      this.dialogTaskVisible = true;
      this.dialogTitle = "添加任务";
      this.dialogLab = "任务名称";
      this.targetIndex = tarIndex;
      this.projectIndex = proIndex;
    },
    //编辑任务,tarIndex为目标index，proIndex为项目index，index为任务index
    editTask: function (tarIndex, proIndex, index) {
      this.dialogTaskVisible = true;
      this.dialogTitle = "编辑任务";
      this.dialogLab = "任务名称";
      this.dataType = 1;
      this.targetIndex = tarIndex;
      this.projectIndex = proIndex;
      this.taskIndex = index;
      this.setting.name = this.items[tarIndex]["project"][proIndex]["task"][
        index
      ].task_name;
      this.setting.percent = this.items[tarIndex]["project"][proIndex]["task"][
        index
      ].percent;
    },
    //保存任务，
    saveTask: function (formName, dataType) {
      let title = this.setting.name;
      let percent = this.setting.percent;
      let id = "";
      let tarIndex = this.targetIndex;
      let proIndex = this.projectIndex;
      if (dataType) {
        let taskIndex = this.taskIndex;
        let task_name = this.items[tarIndex]["project"][proIndex]["task"][
          taskIndex
        ].task_name;
        let task_percent = this.items[tarIndex]["project"][proIndex]["task"][
          taskIndex
        ].percent;
        if (title === task_name && percent === task_percent) {
          this.beforeTaskClose();
          return true;
        }
        id = this.items[tarIndex]["project"][proIndex]["task"][taskIndex].id;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            task_id: id ? id : 0,
            project_id: this.items[tarIndex]["project"][proIndex].id,
            task_name: title,
            percent: percent
          };
          saveTargetProjectTaskTitleData(params).then(response => {
            if (dataType) {
              this.items[tarIndex]["project"][proIndex]["task"][
                this.taskIndex
              ].task_name = title;
              this.items[tarIndex]["project"][proIndex]["task"][
                this.taskIndex
              ].percent = percent;
            } else {
              this.items[tarIndex]["project"][proIndex]["task"].push(
                response.data
              );
            }
            this.calcAllocated(this.items);
            this.dataType = "";
            this.$message.success("保存成功");
            this.beforeTaskClose();
          });
        }
      });
    },
    //删除任务,id为任务id，tarIndex为目标index，proIndex为项目index，index为任务index
    delTask: function (id, tarIndex, proIndex, index) {
      this.$confirm("此操作将永久删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (!id) {
            return true;
          }
          this.items[tarIndex]["project"][proIndex]["task"].splice(index, 1);
          let params = {
            competition_id: this.competitionId,
            task_id: id
          };
          deleteTaskSettingData(params).then(response => {
            this.$message.success("删除成功!");
          });
        })
        .catch(() => { });
    },
    //创建或编辑活动，id为活动id,tarIndex为目标index，proIndex为项目index，taskIndex为任务index,index为活动下标
    editEvents: function (id, tarIndex, proIndex, taskIndex, index) {
      let task_id = this.items[tarIndex]["project"][proIndex]["task"][taskIndex].id;
      let events = {
        targetIndex: tarIndex,
        projectIndex: proIndex,
        taskIndex: taskIndex,
        index: index,
        paperId: id,
        taskId: task_id
      };
      sessionStorage.setItem("eventInfo", JSON.stringify(events));
      sessionStorage.setItem('anchor', 'anchor' + task_id)//设置锚点所用
      this.$router.push({ name: "create-paper" });
    },
    //删除活动
    delEvent: function (id, tarIndex, proIndex, taskIndex, index) {
      this.$confirm("此操作将永久删除该活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (!id) {
            return true;
          }
          this.items[tarIndex]["project"][proIndex]["task"][taskIndex][
            "events"
          ].splice(index, 1);
          let params = {
            competition_id: this.competitionId,
            paper_id: id
          };

          deleteTargetProjectTaskActivityData(params).then(response => {
            this.$message.success("删除成功!");
          });
        })
        .catch(() => { });
    },
    //关闭目标弹窗前
    beforeTargetClose: function () {
      this.dialogTargetVisible = false;
      this.dialogTitle = "";
      this.dialogLab = "";
      this.dataType = "";
      this.setting = {
        name: "",
        percent: ""
      };
      this.$refs["targetForm"].resetFields();
    },
    //关闭任务弹窗前
    beforeTaskClose: function () {
      this.dialogTaskVisible = false;
      this.dialogTitle = "";
      this.dialogLab = "";
      this.dataType = "";
      this.setting = {
        name: "",
        percent: ""
      };
      this.$refs["taskForm"].resetFields();
    },
    //关闭项目弹窗前
    closeProjectDialog: function () {
      this.dialogProjectVisible = false;
      this.dataType = "";
      this.setting = {
        name: "",
        percent: ""
      };
      this.$refs.mychild.resetForm();
    },
    //修改分值占比
    editPercent: function (id, percent) {
      if (percent.match(/[^\d]/g)) {
        // percent = percent.replace(/[^\d]/g, ""); 
        this.$message.error('分值必须为数字')
        return true
      }
      let params = {
        competition_id: this.competitionId,
        id: id,
        percent: percent
      };
      resetPercent(params).then(response => {
        this.calcAllocated(this.items);
      });
    },
    //保存内容
    savePath: function () {
      if (!this.items.length) {
        this.$message.success("尚未添加内容");
        return;
      }
      let targetSort = []; //目标排序
      let projects = []; //提取项目
      this.items.forEach((element, index) => {
        let t = {};
        t.id = element.id;
        t.sort = index + 1;
        targetSort.push(t);
        if (element.project.length) {
          element.project.forEach(pro => {
            pro.target_id = element.id;
            return pro;
          });
          projects[index] = element.project;
        }
      });
      let projectSort = []; //项目排序
      let tasks = []; //提取任务
      projects.forEach((element, index) => {
        element.forEach((item, idx) => {
          let p = {};
          p.id = element[idx].id;
          p.sort = idx + 1;
          p.target_id = element[idx].target_id;
          projectSort.push(p);
          element[idx].task.forEach(pro => {
            pro.project_id = element[idx].id;
            return pro;
          });
          tasks.push(element[idx].task);
        });
      });

      let taskSort = []; //任务排序
      let events = []; //提取活动
      tasks.forEach((element, index) => {
        element.forEach((item, idx) => {
          let t = {};
          t.id = element[idx].id;
          t.sort = idx + 1;
          t.project_id = element[idx].project_id;
          taskSort.push(t);
          element[idx].events.forEach(pro => {
            pro.task_id = element[idx].id;
            return pro;
          });
          events.push(element[idx].events);
        });
      });
      let eventSort = []; //活动排序
      events.forEach((element, index) => {
        element.forEach((item, idx) => {
          let e = {};
          e.id = element[idx].id;
          e.sort = idx + 1;
          e.task_id = element[idx].task_id;
          eventSort.push(e);
        });
      });
      let params = {
        competition_id: this.competitionId,
        targetSort: targetSort,
        projectSort: projectSort,
        taskSort: taskSort,
        eventSort: eventSort
      };
      savePathData(params).then(response => {
        this.$message.success("保存成功");
      });
    },
    //
    checkMove: function (evt) {

    },
    //计算项目数量
    calcProNum: function () {
      for (let i = 0; i < this.items.length; i++) {
        this.nodeNum[i] = 0;
        if (this.items[i].project && this.items[i].project.length) {
          this.nodeNum[i] = this.items[i].project.length;
        }
      }
    },
    //项目按顺序,tarIndex为目标下标值，proIndex为项目下标值
    sortProNum: function (tarIndex, proIndex) {
      let num = 1;
      for (let i = 0; i < tarIndex; i++) {
        num += this.nodeNum[i];
      }
      num += proIndex;
      return num;
    },
    calcTaskNum: function () {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].project && this.items[i].project.length) {
          let projects = this.items[i].project
          for (let j = 0; j < projects.length; j++) {
            this.taskNum[projects[j].id] = 0;
            if (projects[j]['task'] && projects[j]['task'].length) {
              this.taskNum[projects[j]['id']] = projects[j]['task'].length
            }
          }
        }
      }
    },
    sortTaskNum: function (proIndex, proId, index) {
      let num = 1;
      for (let i = 0; i < proIndex; i++) {
        num += this.taskNum[i];
      }
      num += index;
      return num;
    },
    //点击章列表,tarIndex为目标index,index为项目index
    setSection: function (tarIndex, index) {
      let ind = tarIndex + "-" + index;
      let i = this.activeNames.findIndex(val => {
        return val === ind;
      });
      if (i === -1) {
        this.activeNames.push(ind);
      } else {
        this.activeNames.splice(i, 1);
      }
    },
    isInArray: function (value) {
      for (let i = 0; i < this.activeNames.length; i++) {
        if (value === this.activeNames[i]) {
          return true;
        }
      }
      return false;
    },
    //计算已分配的分值
    calcAllocated: function (data) {
      this.total_percent = 0;
      for (let i = 0; i < data.length; i++) {
        data[i].project.forEach((item, index) => {
          item.task.forEach((element, ind) => {
            element.events.forEach((e, i) => {
              this.total_percent += Number(e.percent);
            });
          });
        });
      }
    },
    //项目拖动结束后保存变动
    projectDragEnd: function (evt) {
      let targetFromIndex = evt.from.id;//拖拽前的目标下标
      let targetIndex = evt.to.id;//拖拽后的目标下标
      let oldIndex = evt.oldIndex; //拖拽前的index
      let newIndex = evt.newIndex; //拖拽后的index
      if (targetFromIndex + '-' + newIndex === targetIndex + '-' + oldIndex) {
        return
      }
      //获取拖动的活动项
      let targets = this.items[targetIndex]
      let projectInfo = []
      this.items[targetIndex]['project'].forEach((element, index) => {
        let obj = {
          id: element.id,
          sort: index + 1,
        }
        projectInfo.push(obj)
      });
      let params = {
        competition_id: this.competitionId,
        target_id: this.items[targetIndex].id,
        projectInfo: projectInfo
      }
      projectDragToRefreshData(params).then(response => {
        this.calcAllocated(this.items)
      })
    },
    //任务拖动结束后保存变动
    taskDragEnd: function (evt) {
      let fromId = evt.from.id.split('-');//拖拽前的目标-项目下标
      let toId = evt.to.id.split('-');//拖拽后的目标-项目下标
      let oldIndex = evt.oldIndex; //拖拽前的index
      let newIndex = evt.newIndex; //拖拽后的index
      if (evt.from.id + '-' + oldIndex === evt.to.id + '-' + newIndex) {
        return
      }
      //获取拖动的活动项
      let targetIndex = toId[0];
      let projectIndex = toId[1];
      let projects = this.items[targetIndex]['project']
      let taskInfo = [];
      projects[projectIndex]['task'].forEach((element, index) => {
        let obj = {
          id: element.id,
          sort: index + 1,
        }
        taskInfo.push(obj)
      });
      let params = {
        competition_id: this.competitionId,
        project_id: projects[projectIndex].id,
        taskInfo: taskInfo
      }
      taskDragToRefreshData(params).then(response => {
        this.calcAllocated(this.items)
      })
    },
    //活动拖动结束后保存变动
    itemsDragEnd: function (evt) {
      let toId = evt.to.id.split('-');//拖拽后的目标-项目-任务下标
      let oldIndex = evt.oldIndex; //拖拽前的index
      let newIndex = evt.newIndex; //拖拽后的index
      if (evt.from.id + '-' + oldIndex === evt.to.id + '-' + newIndex) {
        return
      }
      //获取拖动的活动项
      let targetIndex = toId[0];
      let projectIndex = toId[1];
      let taskIndex = toId[2];
      let tasks = this.items[targetIndex]['project'][projectIndex]['task']
      let eventInfo = [];
      tasks[taskIndex]['events'].forEach((element, index) => {
        let obj = {
          id: element.id,
          sort: index + 1,
        }
        eventInfo.push(obj)
      });
      let params = {
        competition_id: this.competitionId,
        task_id: tasks[taskIndex].id,
        eventInfo: eventInfo
      }
      itemDragToRefreshData(params).then(response => {
        this.calcAllocated(this.items)
      })
    },
    //锚点
    getLocal: function () {
      let select = sessionStorage.getItem('anchor')
      let anchorElement = document.getElementById(select)
      if (anchorElement) {
        anchorElement.scrollIntoView()
        sessionStorage.removeItem('anchor')
      }
    }
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  filters: {
    NumberToChinese: function (num) {
      return NumberToChinese(num);
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        // 聚焦元素
        el.querySelector("input").focus();
      }
    }
  }
};
</script>
<style scoped>
@import url("../../assets/css/create.css");
</style>